import { render, staticRenderFns } from "./ItSection.vue?vue&type=template&id=d2dc3bf2&"
import script from "./ItSection.vue?vue&type=script&lang=js&"
export * from "./ItSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports